const seasons = ["22-23", "23-24", "24-25", "25-26", "26-27"];

export default seasons;
